// extracted by mini-css-extract-plugin
export default {"subTitle":"dcc_overviewView-subTitle","envkvLabelWrapper":"dcc_overviewView-envkvLabelWrapper","envkvLabelImage":"dcc_overviewView-envkvLabelImage"};